/**
 * 共通ヘッダー・フッタ
 */
import $ from 'jquery';
import { TweenMax } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { getStyle, offset } from './utility';
import MediaQueries from './Mediaqueries';

const tm = TweenMax;

export const mq = new MediaQueries();
export const lang = document.documentElement.lang;

export default class Global {
	constructor() {
		this.root = document.querySelector('.global-header');
		this.sp_menubtn = document.querySelector('.sp-menu-btn');
		this.cookie_btn = document.querySelector('.cookie__btn');
		this.page_link_btn = document.getElementsByClassName('page-link');
		this.page_top_btn = document.getElementsByClassName('btn-footer__pagetop');
		this.addListeners();
		this.init();
		this.layoutChange(mq.getLayout());
	}

	/**
	 * イベント登録
	 */
	addListeners() {
		window.addEventListener('layoutChange', this.layoutChange.bind(this), false);
		window.addEventListener('headerChange', this.headerChange.bind(this), false);
		if (this.sp_menubtn) this.sp_menubtn.addEventListener('click', this.menuOnClick.bind(this), false);
		this.cookie_btn.addEventListener('click', this.cookieOkClick.bind(this), false);
		for (let i = 0, l = this.page_link_btn.length; i < l; i++) {
			this.page_link_btn[i].addEventListener('click', this.pageLink.bind(this), false);
		}
	}

	/**
	 * 初期処理
	 */
	init() {
		document.body.classList.add(`lang-${lang}`);

		if (navigator.cookieEnabled) {
			var ck = document.cookie.split('; '),
				ck_data = {},
				cki = 0,
				ckl = ck.length,
				cookie = document.querySelector('.cookie');

			for (cki = 0; cki < ckl; cki++) {
				var ck_key = ck[cki].split('=')[0],
					ck_val = ck[cki].split('=')[1];

				ck_data[ck_key] = ck_val;
			}

			if (ck_data.visit && ck_data.visit === 'ok') {
				cookie.parentNode.removeChild(cookie);
			} else {
				cookie.classList.add('cookie--show');
			}
		}
		if($('main').children().attr('id') == 'search_app' || $('main').children('div').attr('id') == 'result'){
			$(this.page_top_btn).show();
		}
	}

	/**
	 * レイアウト切り替え
	 */
	layoutChange(e) {
		const layout = e.detail ? e.detail.layout : e;
		const mq = document.querySelectorAll('.mq');

		for (let i = 0, l = mq.length; i < l; i++) {
			let set = mq[i].getAttribute(`data-${layout}`);

			if (layout === 'tab' && !set) set = mq[i].getAttribute(`data-pc`);

			mq[i].setAttribute('src', set);
		}
	}

	/**
	 * ヘッダ切り替え
	 */
	headerChange(e) {
		this.sp_menubtn = document.querySelector('.sp-menu-btn');
		this.sp_menubtn.addEventListener('click', this.menuOnClick.bind(this), false);
	}

	/**
	 * スマホメニューボタン
	 */
	menuOnClick(e) {
		const menu = document.querySelector('.menu.menu--left');
		const bg = document.querySelector('.sp-menu-bg');

		let menu_h = 0;

		this.root.classList.toggle('global-header--open');

		if (this.root.classList.contains('global-header--open')) {
			bg.classList.add('sp-menu-bg--open');

			tm.set(menu, { css: { height: 'auto' } });
			menu_h = getStyle(menu, 'height');
			tm.set(menu, { css: { height: '' } });

			tm.to(menu, 0.45, {
				css: { height: menu_h },
				onComplete: function() {
					tm.set(this.target, { css: { height: 'auto' } });
				}
			});
			tm.to(bg, 0.45, {
				css: { opacity: 1 }
			});
		} else {
			tm.to(menu, 0.45, {
				css: { height: 0 },
				onComplete: function() {
					tm.set(this.target, { css: { height: '' } });
				}
			});
			tm.to(bg, 0.45, {
				css: { opacity: 0 },
				onComplete: () => {
					bg.classList.remove('sp-menu-bg--open');
				}
			});
		}
	}

	/**
	 * ページ内リンク
	 */
	pageLink(e) {
		const _this = e.currentTarget;
		const target = document.querySelector(_this.getAttribute('data-target'));
		const pos = offset(target, 'top');
		const delay = _this.getAttribute('data-delay') || 0;

		tm.to(window, 0.7, {
			scrollTo: pos,
			delay: delay,
			ease: Power1.easeOut
		});
	}

	/**
	 * クッキーメッセージ消す
	 */
	cookieOkClick() {
		const cookie_dom = document.querySelector('.cookie');

		if (navigator.cookieEnabled) {
			let expire = new Date();
			const limit = 365;

			expire.setTime(expire.getTime() + limit * 1000 * 3600 * 24);
			document.cookie = 'visit=ok; expires=' + expire.toUTCString() + '; path=/';
		}

		tm.to(cookie_dom, 1, {
			css: { opacity: 0 },
			onComplete: function() {
				this.target.style.display = 'none';
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/js/module/Global.js